import { createFileRoute } from '@tanstack/react-router';

import { UnsupportedBrowserPage } from '@/pages/unsupported-browser';

export const Route = createFileRoute('/unsupported-browser')({
    component: UnsupportedBrowserPage,
});
